import { FC } from "react";
import classnames from "classnames";

import { GridCountRange } from "@types";

import s from "./Grid.module.scss";

interface GridProps {
  columns: GridCountRange;
  largeGap?: boolean;
  hasBorder?: boolean;
  hasHoverEffect?: boolean;
  children?: React.ReactNode;
}

export const Grid: FC<GridProps> = ({ columns, largeGap, hasBorder, hasHoverEffect, children }) => {
  return (
    <div
      className={classnames(s.Grid, {
        [s.GridOf2]: columns === "2",
        [s.GridOf3]: columns === "3",
        [s.GridOf4]: columns === "4",
        [s.LargeGap]: largeGap,
        [s.HasBorder]: hasBorder,
        [s.HasHoverEffect]: hasHoverEffect,
      })}
    >
      {children}
    </div>
  );
};
